<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Grant Monthly Service Charge Bypass</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-body-1 mb-2">
                  You are about to grant a service charge bypass for:
                </div>
                <div class="text-h6 primary--text mb-4">
                  {{ user.name }}
                </div>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="info">
                        {{ icons.mdiCheckCircle }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">Customer's next payment will skip <strong>ALL</strong> monthly service charge debt</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="info">
                        {{ icons.mdiCheckCircle }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">Bypass will automatically reset to <strong>false</strong> after the next payment</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="info">
                        {{ icons.mdiCheckCircle }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">The customer will be able to pay their meter bill without deducting monthly service charges</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="warning"
            text
            :loading="isLoading"
            @click="grantBypass()"
          >
            Confirm & Grant Bypass
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import { mdiCheckCircle } from '@mdi/js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isLoading: false,
    icons: {
      mdiCheckCircle,
    },
  }),
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    grantBypass() {
      this.isLoading = true
      axios
        .post('users-grant-monthly-service-charge-bypass', {
          user_id: this.user.id,
        })
        .then(response => {
          this.$notification.success(response.data.message || 'Service charge bypass granted successfully')
          this.$emit('close')
          this.$emit('bypass-granted')
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$notification.error(error.response?.data?.message || 'Failed to grant service charge bypass')
        })
    },
  },
}
</script>
